import React, { useState } from 'react';
import { ReactComponent as Logo } from '../../assets/logo/LogoBlue.svg';
import { Redirect, useLocation } from 'react-router-dom';
import { Input, Button, Alert, Form, Typography } from 'antd';
import { useAuthContext } from '../../context';
import {
  UserOutlined,
  LockOutlined,
  DisconnectOutlined,
} from '@ant-design/icons';

const BaseSignInForm = () => {
  let location = useLocation();
  const [showOfflineRedirect] = useState(false);
  const [redirectToOffline, setRedirectToOffline] = useState(false);
  const {
    doSignInWithEmailAndPassword,
    redirectToReferrer,
    loading,
    error,
    setError,
  } = useAuthContext();
  const { Text } = Typography;

  const onFinish = (values) => {
    doSignInWithEmailAndPassword(values.email?.trim(), values.password);
  };

  const { from } = location.state || { from: { pathname: '/home' } };
  if (redirectToReferrer) return <Redirect to={from} />;
  if (redirectToOffline) return <Redirect to="/offlinemode" />;

  return (
    <div style={{ height: '100%', minHeight: '100vh' }}>
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          padding: '0 20px 0',
          paddingTop: '20vh',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            marginBottom: '30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Logo className="hide-logo-on-keyboard" style={{ height: '64px' }} />
          <Text style={{ fontSize: '24px', fontWeight: '600' }}>mSales</Text>
        </div>
        <Form onFinish={onFinish}>
          {error && (
            <Alert
              message="Pogrešan E-mail ili Password"
              type="error"
              showIcon
              closable
              onClose={() => setError(null)}
            />
          )}
          <Form.Item
            name="email"
            normalize={(value) => value?.trim()}
            rules={[
              {
                required: true,
                type: 'email',
                message: 'E-mail nije validan!',
              },
            ]}
          >
            <Input
              size="large"
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="E-mail"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rule={[
              {
                required: true,
                type: 'password',
                message: 'Molimo unesite password!',
              },
            ]}
          >
            <Input
              type="password"
              size="large"
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item label=" " colon={false}>
            <Button
              loading={loading}
              type="primary"
              size="large"
              htmlType="submit"
              className="login-form-button"
              style={{ width: '100%' }}
            >
              Prijavi se
            </Button>
          </Form.Item>
        </Form>
      </div>
      {showOfflineRedirect && (
        <div style={{ position: 'absolute', bottom: '0px', right: '10px' }}>
          <span onClick={() => setRedirectToOffline(true)}>
            <DisconnectOutlined /> <span>Offline narudžbe</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default BaseSignInForm;
